export default __webpack_public_path__ + "static/Full-Chart-d48cedeb10867f7305406c360dd4ec54.webp";